var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFullLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 545.72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fd694e;\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #09cfab;\n      }\n\n      .cls-3 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "368.08 227.79 239.17 467.49 152.8 467.49 107.65 383.56 107.58 383.42 136.65 383.42 176.07 417.17 338.27 227.79 368.08 227.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "368.08 188.49 339.01 188.49 299.63 154.74 137.42 344.11 107.58 344.11 236.49 104.41 322.85 104.41 367.97 188.34 368.08 188.49"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M610.01,134.01h-23.43c-15.84,0-27.8,3.98-35.93,11.93-8.13,7.88-12.18,19.6-12.18,35.16v52.75h-46.88c-13.69,0-24.25-3.2-31.67-9.5-7.39-6.44-11.05-16.05-11.05-28.89v-61.45h-16.82v63.13c0,35.65,18.65,53.49,55.96,53.49h67.39v-70.07c0-19.81,10.45-29.77,31.43-29.77l23.18.18v-16.96Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 649.72,
    y: 103.71,
    width: 16.68,
    height: 88.61
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M741.33,222.55c6.23,4.26,13.62,6.48,22.14,6.62v.03h72.43v-95.2h-16.82v78.41h-54.51c-9.57,0-17-3.13-22.17-9.4-5.14-6.3-7.71-14.64-7.71-25.02v-100.33h-16.82v97.91c0,12.18-3.45,21.36-10.38,27.59-6.93,6.16-17,9.26-30.16,9.26h-89.72v16.79h90.5c24.78,0,41.49-7.95,50.15-23.86,2.32,7.04,6.69,12.77,13.09,17.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M555.27,384.37c5.55-6.99,8.34-15.59,8.34-25.79v-.13c0-8.73-2.05-16.1-6.16-22.2-4.11-6.16-9.85-10.84-17.2-14.12-7.38-3.24-16.01-4.88-25.92-4.88h-82.28v138.97h16.81v-54.79h67l36.7,54.79h19.12l-38.88-57.23c9.5-2.73,16.97-7.6,22.46-14.63ZM512.28,385.66h-63.41v-52.61h63.41c10.01,0,18.13,2.05,24.38,6.16,6.32,4.11,9.5,10.59,9.5,19.38v.13c0,8.82-3.18,15.53-9.5,20.15-6.26,4.56-14.37,6.8-24.38,6.8Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "611.52 392.46 704.96 392.46 704.96 376.8 611.52 376.8 611.52 333.04 711.37 333.04 711.37 317.26 594.71 317.26 594.71 456.24 712.14 456.24 712.14 440.45 611.52 440.45 611.52 392.46"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 875.61,
    y: 317.26,
    width: 16.81,
    height: 138.97
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M875.6,134v85.34c0,11.02-2.25,19.14-6.65,24.35-4.47,5.31-11.37,7.99-20.69,7.99-2.32,0-4.58-.07-6.79-.21v15.03c3.03.25,6.62.42,10.03.42,27.27,0,40.93-15.87,40.93-47.58v-85.34h-16.82Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 804.65,
    cy: 258.88,
    r: 10.11
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M766.84,258.88c0,5.59,4.53,10.11,10.11,10.11s10.11-4.53,10.11-10.11-4.53-10.11-10.11-10.11-10.11,4.53-10.11,10.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M525,280.99c0-5.58-4.53-10.11-10.11-10.11s-10.11,4.53-10.11,10.11,4.53,10.11,10.11,10.11,10.11-4.53,10.11-10.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M497.31,280.99c0-5.58-4.53-10.11-10.11-10.11s-10.11,4.53-10.11,10.11,4.53,10.11,10.11,10.11,10.11-4.53,10.11-10.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M758.63,433c-4.4-5.21-6.65-13.34-6.65-24.35v-91.39h-16.82v91.39c0,31.71,13.66,47.58,40.93,47.58h76.51v-15.77h-79.99c-5.98-1.02-10.66-3.52-13.97-7.46Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullLogo);
export default __webpack_public_path__ + "static/media/full_logo.9c3e0142abe642db8716ceeca31b8bea.svg";
export { ForwardRef as ReactComponent };